var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_card"},[_c('span',{staticClass:"cardmedia"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"leftx"},[_vm._v("X")])])}
var staticRenderFns = []

export { render, staticRenderFns }